import { aboutContent } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            关于菲菲
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            了解菲菲影院的故事与使命
          </p>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10">
          <div className="flex flex-col md:flex-row items-start gap-6">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-background-50 text-3xl md:text-4xl"></i>
              </div>
            </div>
            <div>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {aboutContent.content}
              </p>
              <div className="flex flex-wrap gap-4 mt-6">
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                  <span>20000+ 剧集资源</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                  <span>每日50+集同步更新</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                  <span>1080P高清不缓冲</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-500">
                  <i className="ri-checkbox-circle-line text-primary-500 text-lg"></i>
                  <span>完全免费无需注册</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}